import { FirmStatusTitles } from './constants';
import { Firm } from './types';

export const getFirmStatusTitle = (firm: Firm) =>
  firm.active ? FirmStatusTitles.ACTIVE : FirmStatusTitles.SUSPENDED;
